import {StyleSheet, View} from 'react-native';
import {Loading} from 'interface/base/Loading';
import {theme} from 'config/themes';

export function Splash() {
  return (
    <View style={styles.root}>
      <Loading/>
    </View>
  );
}

export const styles = StyleSheet.create({
  root: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.login.fill,
  },
});
